import { aresManager } from '@shared/manager';
import TRPC from '@/utils/trpc';
import Logger from '@/utils/logger';
import Reporter from '@/utils/reporter';
import Tools from '@tencent/nb-h5-tools';
import JsBridge from '@tencent/nb-js-bridge';

aresManager.setConfig({
  trpc: TRPC,
  logger: Logger,
  reporter: Reporter,
  tools: Tools,
  jsbridge: JsBridge,
});
